
import three from './MyStuff1/Interview/3.jpg'
import four from './MyStuff1/Interview/4.jpg'
import five from './MyStuff1/Interview/5.jpg'
import six from './MyStuff1/Interview/6.jpg'
import seven from './MyStuff1/Interview/7.jpg'
import eight from './MyStuff1/Interview/8.jpg'
import nine from './MyStuff1/Interview/9.jpg'
import ten from './MyStuff1/Interview/10.jpg'
import eleven from './MyStuff1/Interview/11.jpg'
import twelve from './MyStuff1/Interview/12.jpg'
import boys from './MyStuff1/Interview/boys.jpg'


const myStuff = [
    
    {
        "index":2,
        "url": three

    },
    {
        "index":3,
        "url": four

    },
    {
        "index":4,
        "url": five

    },
    {
        "index":5,
        "url": six

    },
    {
        "index":6,
        "url": seven

    },
    {
        "index":7,
        "url": eight

    },
    {
        "index":8,
        "url": nine

    },
    {
        "index":9,
        "url": ten

    },
    {
        "index":10,
        "url": eleven

    },
    {
        "index":11,
        "url": twelve

    },
    {
        "index":11,
        "url": boys

    }
   

]

export default myStuff;